import { gql } from "@apollo/client";

export default gql`
  query getProfileOneononesQuery(
    $subject: Int!
    $now: DateTime!
    $beforeDate: DateTime!
    $includeUpcoming: Boolean!
    $upcomingFirst: Int!
    $upcomingCursor: String
    $pastFirst: Int!
    $pastCursor: String
  ) {
    upcoming: meetings(
      isFormalOneonone: true
      subject: $subject
      startDatetime_Gte: $now
      first: $upcomingFirst
      after: $upcomingCursor
      orderBy: "start_datetime"
    ) @include(if: $includeUpcoming) {
      edges {
        node {
          id
          title
          startDatetime
          meetingGroupId
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
    # 1-on-1s with no date at all. They match NEITHER bucket above (both filter
    # on startDatetime), so the tab has to ask for them separately to know one
    # exists — see the "start one now" card in profile-oneonone-tab.
    unscheduled: meetings(
      isFormalOneonone: true
      subject: $subject
      unscheduled: true
      first: 1
    ) @include(if: $includeUpcoming) {
      edges {
        node {
          id
        }
      }
    }
    past: meetings(
      isFormalOneonone: true
      subject: $subject
      startDatetime_Lt: $beforeDate
      first: $pastFirst
      after: $pastCursor
      orderBy: "-start_datetime"
    ) {
      edges {
        node {
          id
          title
          startDatetime
          meetingGroupId
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`;
